import { useState, useEffect } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { buildSignupUrl } from '../../lib/signupUrl';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const signupUrl = buildSignupUrl();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#features', label: 'Features' },
    { href: '#how-it-works', label: 'How it works' },
    { href: '#pricing', label: 'Pricing' },
    { href: '#testimonials', label: 'Reviews' },
  ];

  return (
    <nav 
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled 
          ? 'top-14 md:top-10 px-4 md:px-8' 
          : 'top-16 md:top-12 px-4 md:px-8'
      }`}
      data-testid="navigation"
    >
      <div className={`max-w-5xl mx-auto glass-strong rounded-full py-3 px-6 flex items-center justify-between transition-all duration-300 ${
        isScrolled ? 'shadow-2xl' : ''
      }`}>
        {/* Logo */}
        <a href="#" className="flex items-center gap-1 group" data-testid="nav-logo">
          <span className="text-xl font-heading font-bold text-white">Adori</span>
          <span className="text-xl font-heading font-bold text-brand-primary">AI</span>
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-gray-300 hover:text-white transition-colors font-medium"
              data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA Button */}
        <a
          href={signupUrl}
          className="hidden md:flex items-center gap-2 bg-brand-primary hover:bg-brand-primary-hover text-surface-base px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 hover:-translate-y-0.5 glow-primary"
          data-testid="nav-cta"
        >
          Start free trial <ArrowRight className="w-4 h-4" />
        </a>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-white p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          data-testid="mobile-menu-toggle"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden mt-2 mx-4 glass-strong rounded-2xl p-6 space-y-4" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="block text-gray-300 hover:text-white transition-colors font-medium py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href={signupUrl}
            className="flex items-center justify-center gap-2 bg-brand-primary hover:bg-brand-primary-hover text-surface-base px-5 py-3 rounded-full text-sm font-semibold transition-all w-full mt-4"
            data-testid="mobile-menu-cta"
          >
            Start free trial <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
